import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { ReservationService } from '../../reservations.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { IMyDrpOptions } from 'mydaterangepicker';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { Subscription } from 'rxjs/Subscription';
import { resetServiceEnabled, verifyServiceEnabled } from '../../../A2-utils/export-functions/functions-services';
import { ParentModule } from 'app/pages/A2-utils/ParentClass/parent-module';
import { modalSwal } from 'app/utils/helpers';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';

declare const moment: any;

@Component({
  selector: 'app-edit-standing-order',
  templateUrl: './edit-standing-order.component.html',
  styleUrls: ['./edit-standing-order.component.scss']
})

export class EditStandingOrderComponent extends ParentModule implements OnInit, OnChanges, OnDestroy {
  @Input() standingOrderId: number;
  @Output() closeNewEditReservationForm: EventEmitter < any > = new EventEmitter < any > ();
  @Output() reloadGrids: EventEmitter < any > = new EventEmitter<any>();
  @ViewChild('startDateForm') private startDateForm: T2CardComponent;
  protected standingOrderForm: FormGroup;
  protected tab: number;
  protected editBtn = false;
  protected saveBtn = false;
  protected data: any;
  public tabs = 1;
  startDate: any;
  startDateChanges: any;
  public validInnerForm = true;
  public myRangeDatePickerOptions: IMyDrpOptions = {
    dateFormat: 'mm-dd-yyyy',
    componentDisabled: true
  };
  protected modelDatePicker: any;
  saving = false;
  private observables: Subscription[] = [];
  dataEditStanding = [];
  @ViewChild('historySO') private historySO: T2CardComponent;

  disabledBtn: boolean;
  // TODO ESTATUS SO
  protected standingorderstatusid: any;

  constructor(
    protected service: ReservationService,
    protected fb: FormBuilder,
    private loading: T2LoadingService,
    protected Inject: Injector,
    private cdRef : ChangeDetectorRef,
    private toastrAlertHelper: ToastrAlertHelper,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    super('app-edit-reservation-form', Inject);
    this.createForm();
  }

  /**
   * @description
   */
  ngOnInit() {
  }


  /**
   * @description
   * @param {SimpleChanges} changes
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes['standingOrderId']) {
      this.startDateChanges = '';
      if (this.editBtn) {
        const dataId = changes['standingOrderId'].previousValue;
       this.unlockStandingOrder(() => {}, () => {}, dataId);
        this.editBtn = false;
      }
      this.getStandingOrder();
    }
  }
  /**
   * @description
   */
  getStandingOrder() {
    this.loading.show();
    this.observables.push(
    this.service.getTripsToStandingOrder(this.standingOrderId)
      .finally(() => {
        this.loading.hiden();
      })
      .subscribe(
        data => {
          if (data) {
            this.patchForm(data);
            this.dataEditStanding = data;
            this.service.setStandingOrderTrips(data.trips);
          }
        }
      )
    );
  }
  /**
   * @description
   */
  createForm() {
    this.standingOrderForm = this.fb.group({
      standingorderId: 0,
      fromdate: '',
      todate: '',
      startdatechanges: '',
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      reviewed: false,
      trips: ''
    });
  }
  /**
   * @description
   */
  submitFormStanding() {
    if (!this.isAllowedAction('EditStandingOrder')) {
      this.sweetAlertHelper.createCustomAlert({title: 'Error', text: `You don't have permission to perform this action`, type: 'error'});
      return;
    }
    if (this.editBtn) {
      if (this.isAllowedAction('Allow So Changes By Date')) {
        this.assignDateToDatePicker(this.dataEditStanding['fromdate'], this.dataEditStanding['todate']);
        this.startDateForm.open();
      } else {
        this.updateSO();
      }
    } else {
      this.lockStandingOrder(() => {
        this.editBtn = true;
        this.saveBtn = false;
      }, (e) => {
        this.toastrAlertHelper.error(e.message);
      });
    }
  }

  updateSO() {
    this.loading.show();
    const dataSO = JSON.parse(JSON.stringify(this.standingOrderForm.value));
    delete (dataSO.trips);
    dataSO.trips = this.data;
    this.cdRef.detectChanges();
    this.startDateChanges ? dataSO.startdatechanges = this.startDateChanges : dataSO.startdatechanges = '';
    this.saving = true;
    if (verifyServiceEnabled('servicePutDataStandingOrderMulti')) {
      this.observables.push(this.service.putDataStandingOrderMulti(dataSO)
        .finally(() => {
          this.loading.hiden();
          this.saving = false;
          resetServiceEnabled('servicePutDataStandingOrderMulti');
        })
        .subscribe(
          resp => {
            this.editBtn = false;
            this.saveBtn = true;
            modalSwal('', 'success', resp.message);
            this.reloadGrids.emit(true);
            this.unlockStandingOrder(() => {}, () => {});
          },
          error => {
            modalSwal('Error', 'error', error.message);
            this.editBtn = true;
            this.saveBtn = false;
          }
        )
      );
    }
  }

  /**
   * this lock standing order
   * @param callback
   * @param errorCallback
   */
  private lockStandingOrder(callback, errorCallback) {
    this.loading.show();
    if (verifyServiceEnabled('serviceLockStandingOrder')) {
      this.observables.push(this.service.lockStandingOrder(this.standingOrderId)
        .subscribe(
          () => {
            this.loading.hiden();
            resetServiceEnabled('serviceLockStandingOrder');
            callback();
          },
          (error) => {
            errorCallback(error);
            this.loading.hiden();
            resetServiceEnabled('serviceLockStandingOrder');
          }
        )
      );
    }
  }

  /**
   * Unlock standing order
   * @param callback
   * @param errorCallback
   * @param id standingOrderId
   */
  private unlockStandingOrder(callback, errorCallback, id?: number) {
    const standingOrderId = id ? id : this.standingOrderId;
    if (verifyServiceEnabled('serviceUnlockStandingOrder')) {
     this.service.unlockStandingOrder(standingOrderId)
         .toPromise().then(
         () => {
           resetServiceEnabled('serviceUnlockStandingOrder');
           callback();
         },
         (error) => {
           errorCallback(error);
         }
       );
    }
  }

  /**
   * @description
   * @param data
   */
  patchForm(data) {
    this.tab = data.trips[0].tripid;
    this.standingOrderForm.patchValue({
      standingorderId: data.standingorderid,
      fromdate: data.fromdate,
      startdatechanges: data.startdatechanges,
      todate: data.todate,
      sunday: data.sunday,
      monday: data.monday,
      tuesday: data.tuesday,
      wednesday: data.wednesday,
      thursday: data.thursday,
      friday: data.friday,
      saturday: data.saturday,
      trips: data.trips,
      reviewed: data.reviewed
    });
    this.data = data.trips;
    this.assignDateToDatePicker(data.fromdate, data.todate);
    // TODO ESTATUS SO
    this.standingorderstatusid = data.standingorderstatusid;
  }

  assignDateToDatePicker(begin, end) {
    begin = (moment(begin));
    end = (moment(end));

    this.modelDatePicker = {
      beginDate: {
        year: begin.year(),
        month: begin.month() + 1,
        day:  begin.date()
      },
      endDate: {
        year: end.year(),
        month: end.month() + 1,
        day: end.date()
      }
    };
    this.startDate = this.getDateFormatted(this.modelDatePicker.beginDate);
  }

  loadStartDateForm(event: any) {
    if (event) {
      this.startDateChanges = event;
      this.startDateForm.close();
      this.updateSO();
    }
  }

  getDateFormatted(date) {
    return date.month + '-' + date.day + '-' + date.year;
  };

  /**
   * @description
   */
  protected closeNewEditReservationBtn() {
    this.closeNewEditReservationForm.emit(false);
  }

  /**
   * @description
   * @param trip
   * @param tripId
   */
  getDataToStandingOrder(trip, tripId) {
    this.data = this.data.map((item) => {
      if (item.tripid === tripId) {

        if (trip.totalamount === null || trip.totalamount === undefined) {
          trip.totalamount = item.totalamount;
        }

        if (trip.totalamountlyft === null || trip.totalamountlyft === undefined) {
          trip.totalamountlyft = item.totalamountlyft;
        }

        return trip;
      }

      return item;
    });
  }

  onValidForm(event) {
    this.validInnerForm = event;
  }

  onValidateTime(event) {
    event ? this.disabledBtn = event : this.disabledBtn = event;
  }

  get disabledBtnSave(): boolean {
    return (!this.validInnerForm && this.editBtn) || this.disabledBtn;
  }

  ngOnDestroy() {
    this.cdRef.detach();
    this.unlockStandingOrder(() => {}, () => {});
    this.observables.forEach(
      (sub: Subscription) => {sub.unsubscribe(); }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/edit-reservation/edit-standing-order/edit-standing-order.component.ts